<template>
  <div class="Glass">
    <div class="page-title">{{title}}</div>
    <el-tabs ref="tabs" v-model="activeTab" type="card">
      <el-tab-pane :label="$t('title.door_cost')" name="0">
        <DoorCost v-if="activeTab === '0'" :has_grant_write="has_grant_write" />
      </el-tab-pane>
      <el-tab-pane :label="$t('title.door_color_cost')" name="1">
        <DoorColorCost v-if="activeTab === '1'" :has_grant_write="has_grant_write" />
      </el-tab-pane>
      <el-tab-pane :label="$t('title.door_mapping')" name="2">
        <DoorMapping v-if="activeTab === '2'" :has_grant_write="has_grant_write" />
      </el-tab-pane>
      <el-tab-pane :label="$t('title.door_color')" name="3">
        <DoorColor v-if="activeTab === '3'" :has_grant_write="has_grant_write" />
      </el-tab-pane>
      <el-tab-pane :label="$t('title.customer_door_level')" name="4">
        <CustomerDoorLevel v-if="activeTab === '4'" :has_grant_write="has_grant_write" />
      </el-tab-pane>
      <el-tab-pane :label="$t('title.door_option')" name="5">
        <Option 
          v-if="activeTab === '5'" 
          kind='DOOR'
          :has_grant_write="has_grant_write" 
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { authority_level } from "@/common/mixins/authority_level";
import DoorCost from "./DoorCost"
import DoorColorCost from "./DoorColorCost"
import DoorMapping from "./DoorMapping"
import DoorColor from "./DoorColor"
import CustomerDoorLevel from "./CustomerDoorLevel"
import Option from "./Option"

export default {
  name: "Glass",
  mixins: [authority_level],
  components: {
    DoorCost,DoorColorCost, DoorMapping, DoorColor, CustomerDoorLevel, Option
  },
  data() {
    return {
      title: this.$t('title.door'),  
      activeTab: '0',
    }
  },
  computed: {
    has_grant_write() {      
      return this.isWriteLevel('door');
    },
  },
}
</script>
